import { combineReducers } from 'redux';
import { getJSON } from 'redux-api-middleware';
import _ from 'lodash';
import apiGenerator from '../apiGenerator';
import Contact, { contactToApiMap } from '../../models/Contact';
import { mapModelToApi, mapApiToModel } from '../../models/modelMapper';

// Actions
const GET_CONTACTS_REQUEST = 'ctm/contacts/GET_CONTACTS_REQUEST';
const GET_CONTACTS_SUCCESS = 'ctm/contacts/GET_CONTACTS_SUCCESS';
const GET_CONTACTS_FAILURE = 'ctm/contacts/GET_CONTACTS_FAILURE';
const ADD_CONTACT_REQUEST = 'ctm/contacts/ADD_CONTACT_REQUEST';
const ADD_CONTACT_SUCCESS = 'ctm/contacts/ADD_CONTACT_SUCCESS';
const ADD_CONTACT_FAILURE = 'ctm/contacts/ADD_CONTACT_FAILURE';
const UPDATE_CONTACT_REQUEST = 'ctm/contacts/UPDATE_CONTACT_REQUEST';
const UPDATE_CONTACT_SUCCESS = 'ctm/contacts/UPDATE_CONTACT_SUCCESS';
const UPDATE_CONTACT_FAILURE = 'ctm/contacts/UPDATE_CONTACT_FAILURE';
const DELETE_CONTACT_REQUEST = 'ctm/contacts/DELETE_CONTACT_REQUEST';
const DELETE_CONTACT_SUCCESS = 'ctm/contacts/DELETE_CONTACT_SUCCESS';
const DELETE_CONTACT_FAILURE = 'ctm/contacts/DELETE_CONTACT_FAILURE';

// Action Creators
export function fetchContacts() {
  return apiGenerator({
    endpoint: 'contacts',
    method: 'GET',
    types: [
      GET_CONTACTS_REQUEST,
      {
        type: GET_CONTACTS_SUCCESS,
        payload: (action, state, res) =>
          getJSON(res).then(data => data.map(d => mapApiToModel(d, contactToApiMap, Contact))),
      },
      GET_CONTACTS_FAILURE,
    ],
  });
}

export function createNewContact(contact, onSuccess, onFailure) {
  return (dispatch) => {
    dispatch(apiGenerator({
      endpoint: 'contacts',
      method: 'POST',
      body: mapModelToApi(new Contact(contact), contactToApiMap),
      types: [
        ADD_CONTACT_REQUEST,
        {
          type: ADD_CONTACT_SUCCESS,
          payload: async (action, state, res) =>
            getJSON(res).then(data => mapApiToModel(data, contactToApiMap, Contact)),
        },
        ADD_CONTACT_FAILURE,
      ],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}

export function updateContact(contact, onSuccess, onFailure) {
  const updated = new Contact(contact);

  return (dispatch) => {
    return dispatch(apiGenerator({
      endpoint: `contacts/${updated.id}`,
      method: 'PUT',
      body: mapModelToApi(updated, contactToApiMap),
      types: [
        UPDATE_CONTACT_REQUEST,
        {
          type: UPDATE_CONTACT_SUCCESS,
          payload: async (action, state, res) =>
            getJSON(res).then(data => mapApiToModel(data, contactToApiMap, Contact)),
        },
        UPDATE_CONTACT_FAILURE,
      ],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}

export function deleteContact(id, onSuccess, onFailure) {
  return (dispatch) => {
    dispatch(apiGenerator({
      endpoint: `contacts/${id}`,
      method: 'DELETE',
      types: [DELETE_CONTACT_REQUEST, DELETE_CONTACT_SUCCESS, DELETE_CONTACT_FAILURE],
    }))
      .then((r) => {
        if (r.error) {
          onFailure(r.payload);
        } else {
          onSuccess(r.payload);
        }
      })
      .catch(onFailure);
  };
}

// Reducers
export function items(state = [], action) {
  switch (action.type) {
    case GET_CONTACTS_SUCCESS:
      return action.payload;
    case ADD_CONTACT_SUCCESS:
      return [...state, action.payload];
    case UPDATE_CONTACT_SUCCESS: {
      return [...state.filter(c => c.id !== action.payload.id), action.payload];
    }
    default:
      return state;
  }
}

export function itemsById(state = {}, action) {
  switch (action.type) {
    case GET_CONTACTS_SUCCESS:
      return _.keyBy(action.payload, 'id');
    case ADD_CONTACT_SUCCESS:
      return Object.assign({}, state, { [action.payload.id]: action.payload });
    case UPDATE_CONTACT_SUCCESS: {
      const newState = Object.assign({}, state);
      newState[action.payload.id] = action.payload;
      return newState;
    }
    default:
      return state;
  }
}

export function isFetching(state = false, action) {
  switch (action.type) {
    case GET_CONTACTS_REQUEST:
      return !action.error;
    case GET_CONTACTS_SUCCESS:
    case GET_CONTACTS_FAILURE:
      return false;
    default:
      return state;
  }
}

export function fetched(state = false, action) {
  switch (action.type) {
    case GET_CONTACTS_SUCCESS:
      return new Date();
    default:
      return state;
  }
}

export function inflightContact(state = new Contact(), action) {
  switch (action.type) {
    case ADD_CONTACT_SUCCESS:
      return new Contact();
    default:
      return state;
  }
}

export default combineReducers({
  items,
  itemsById,
  isFetching,
  fetched,
  inflightContact,
});



// WEBPACK FOOTER //
// ./src/redux/ducks/contacts.js